import { SendRequestOptions } from '@mews/framework';
import { RestApiOptions } from './types';

// Cleanup task https://mews.myjetbrains.com/youtrack/issue/kanban-4402
const resDiaryProxyUrl = '/resDiary/universal';
export const createResDiaryUniversalRequest =
    ({ request }: RestApiOptions) =>
    async (url: string, params?: object | null, { method }: SendRequestOptions = { method: 'GET' }) => {
        const data = {
            method,
            url,
            body: params && JSON.stringify(params),
        };

        return request(resDiaryProxyUrl, data).then(parseProxyResponse);
    };

export const parseProxyResponse = ({ response }: { response: string }) => {
    const jsonResponse = response && JSON.parse(response);
    return jsonResponse && transformToLowerFirstKeys(jsonResponse);
};

// @ts-expect-error
const transformToLowerFirstKeys = (obj) => {
    if (!obj) {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map(transformToLowerFirstKeys);
    }

    if (typeof obj === 'object') {
        return Object.keys(obj).reduce((acc, key) => {
            const firstLetter = key.slice(0, 1);
            const otherKey = key.slice(1);
            const lowerKey = firstLetter.toLowerCase().concat(otherKey);

            // @ts-expect-error
            acc[lowerKey] = transformToLowerFirstKeys(obj[key]);

            return acc;
        }, {});
    }

    return obj;
};
